/*
 * Copyright (c) 2021 by Leyton Group - All Rights Reserved.
 *  This source code, and resulting software, is the confidential and proprietary information
 *  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
 *  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
 *  and shall use it only in accordance with the terms and conditions of any and all license
 *  agreements you have entered into with The Company.
 */
const doesJWTCookieExist = function(cookieName) {
  const d = new Date();
  const ONE_THOUSAND = 1000;
  d.setTime(d.getTime() + ONE_THOUSAND);
  const expires = "expires=" + d.toUTCString();

  document.cookie = cookieName + "=new_value;path=/;" + expires;
  return document.cookie.indexOf(cookieName + "=") === -1;
};

const createCookie = function(name, body) {
  const date = new Date();
  const TEN_THOUSAND = 10000;
  date.setTime(date.getTime() + TEN_THOUSAND);
  const expires = "expires=" + date.toUTCString();

  document.cookie = `${name}=${body};path=/;` + expires;
};

const deleteCookie = function(name) {
  document.cookie = `${name}=; Max-Age=0; path=/;`;
};

export const cookieUtils = {
  doesJWTCookieExist,
  createCookie,
  deleteCookie
};
